import { z } from 'zod'

/** 필기 종류. S3 경로의 prefix 를 정하고, 종류에 따라 id·subId 가 가리키는 대상이 다르다 */
export const HANDWRITTEN_NOTE_TYPE = [
  'STUDENT_WORKSHEET_SCORING',
  'STUDENT_WORKSHEET_SCORING_TEACHER',
  'SIGNATURE_WORKBOOK_PAGE',
  'ACADEMY_GROUP_WORKBOOK_PAGE',
  'STUDENT_EXAM_SCORING',
  'ASSIGNED_CAS_SCORING',
  'CREVERSE_GUEST_ENTRANCE_WORKSHEET_SCORING',
  'CREVERSE_GUEST_ENTRANCE_CAS_SCORING',
  'STUDENT_WORKSHEET_ESSAY_SLOT',
] as const
export const HandwrittenNoteTypeSchema = z.enum(HANDWRITTEN_NOTE_TYPE)
export type HandwrittenNoteType = z.infer<typeof HandwrittenNoteTypeSchema>

// 필기 캔버스 하나를 가리키는 키. id 는 상위 식별자(학습지·시험·교재 판 등), subId 는 하위 식별자(문항·페이지 등)다.
// 같은 문항이라도 학생·선생님·서술형 슬롯은 서로 다른 캔버스다.
export const HandwrittenNoteKeySchema = z.object({
  id: z.number(),
  subId: z.number(),
  type: HandwrittenNoteTypeSchema,
  /** 서술형 슬롯 필기(STUDENT_WORKSHEET_ESSAY_SLOT)만 쓰는 세 번째 축 — 1-based 슬롯 번호 */
  tag: z.number().optional(),
})
export type HandwrittenNoteKey = z.infer<typeof HandwrittenNoteKeySchema>

// 필기 JSON 의 공개 주소. 경로가 키로 정해져 필기가 아직 없어도 주소는 늘 채워진다 — 403/404 는 '아직 필기 없음' 이다.
// 2026-10-16 백엔드 develop(b1add2a8c) 의 handwrittenNote/controller/response/HandwrittenNoteUrlsResponse.kt 로 확인.
export const HandwrittenNoteUrlSchema = z.object({
  id: z.number(),
  subId: z.number(),
  type: HandwrittenNoteTypeSchema,
  tag: z.number().nullable(),
  url: z.string(),
})
export type HandwrittenNoteUrl = z.infer<typeof HandwrittenNoteUrlSchema>

// 필기를 올릴 presigned 주소. 서버는 발급하지 못한 키의 주소를 null 로 낸다(`URL?`).
// 2026-10-16 백엔드 develop(b1add2a8c) 의 HandwrittenNotePresignedUrlResponse.kt 로 확인.
export const HandwrittenNotePresignedUrlSchema = z.object({
  id: z.number(),
  subId: z.number().nullable(),
  type: HandwrittenNoteTypeSchema,
  tag: z.number().nullable(),
  presignedUrl: z.string().nullable(),
})
export type HandwrittenNotePresignedUrl = z.infer<typeof HandwrittenNotePresignedUrlSchema>
